import { FunctionComponent } from "react";

import { Button } from "@chakra-ui/react";
import { FileContainer } from "am-tax-fe-core";

import { map, mapList } from "./upload-btn-utils";

interface Props {
    title: string;
    accept?: string;
    multiple?: boolean;
    onFileSelectionChanged: (files: FileContainer[] | FileContainer | undefined) => void;
    variant?: "solid" | "outline" | "ghost" | "link" | undefined;
    isMenuLink?: boolean | undefined;
    isLoading?: boolean | undefined;
    hasAccess?: boolean;
}

const UploadButton: FunctionComponent<Props> = ({
    title,
    accept = "*",
    multiple = false,
    onFileSelectionChanged,
    variant = "solid",
    isMenuLink = false,
    isLoading = false,
    hasAccess,
}) => {
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files) {
            onFileSelectionChanged(undefined);
        } else if (!multiple) {
            onFileSelectionChanged(map(files[0], 0));
        } else {
            onFileSelectionChanged(mapList(files));
        }
        // DEV-NOTE: forces onChange to trigger a second time with the same file
        e.target.value = "";
    };

    const handleUploadBtnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        const parent = e.currentTarget.parentNode as HTMLButtonElement;
        if (parent) {
            parent?.click();
        }
    };

    return (
        <>
            <input type="file" id={title} onChange={handleFileChange} accept={accept} multiple={multiple} hidden />
            <label htmlFor={title}>
                <Button
                isDisabled={hasAccess === false}
                    onClick={handleUploadBtnClick}
                    variant={variant}
                    isLoading={isLoading}
                    sx={{ fontWeight: isMenuLink ? "normal" : "inherit", color: isMenuLink ? "blackAlpha.800" : "inherit" }}
                >
                    {title}
                </Button>
            </label>
        </>
    );
};

export default UploadButton;
